module.exports = __webpack_public_path__ + "img/view-dark.21ebacba.svg";